import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app.js";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (!root) throw new Error("Application root is missing");
createRoot(root).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);
